import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  Table,
  TableColumn,
  DatePicker,
  Progress,
  Select,
  Option,
  Input,
  Button,
  Pagination,
  Dialog,
  Drawer,
} from "element-ui";
import MDialog from "vue-m-dialog"; // ro import { Dialog, Alert, Confirm } from 'vue-m-dialog'
import "vue-m-dialog/dist/index.css";
import dataV from "@jiaminghi/data-view";
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.use(dataV);
import api from "@/api";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Progress);
Vue.use(MDialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Button);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(api);
Vue.use(Drawer);

Vue.config.productionTip = false;

router.afterEach((to, from) => {});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
